<template>
    <div class="h-full">
        <div v-if="absences.length > 0">
            <h5>{{transEdit('temp.vacancies')}}</h5>
            <div v-for="absence in absences" class="p-1 pl-1 pl-2 pr-1 mt-1 border rounded">
                <div class="d-flex align-items-center">
                    <div class="flex-1">
                        {{transEdit('temp.vacancy-for')}} {{absence.therapist.user.name}}
                    </div>
                    <div class="flex-1 font-bold">
                        {{getFormattedDateTime(absence.absence_start)}} - {{getFormattedDateTime(absence.absence_end)}}
                    </div>
                    <div class="flex-1">
                         {{absence.location.address}}, {{absence.city.name}}
                    </div>
                    <div class="flex-1 text-center">{{absence.location.primary_company.name}}</div>
                    <div class="text-right flex-shrink-1">
                        <a class="btn btn-primary" :href="$portalUrl('therapist_absences/' + absence.id)"><i class="fa fa-search"></i> Visa</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="flex">
            <div class="w-1/4">
                <div class="flex flex-col pr-4 mt-16 space-y-2">
<!--                    <button class="w-full py-2 border border-black rounded" @click="toggleWeekSchedule" v-if="showWeeklySchedule"><i class="fa fa-calendar"></i> {{transEdit('show-dayschedule')}}</button>-->
<!--                    <button class="w-full py-2 border border-black rounded" @click="toggleWeekSchedule" v-else><i class="fa fa-calendar"></i> {{transEdit('show-weekschedule')}}</button>-->
                    <button v-if="lockedByAdmin" class="w-full py-2 text-red-500 border border-red-500 rounded" disabled><i class="fa fa-lock"></i> {{transEdit('Månaden kan inte låsas upp')}}</button>
                    <button v-if="is_admin && (selectedDate || monthIsLocked) && !lockedByAdmin" class="w-full py-2 border border-black rounded" @click="unlockMonth"><i class="fa fa-unlock"></i> {{transEdit('Lås upp månad')}}</button>
                    <button v-if="!selectedDayIsLocked && !monthIsLocked" class="w-full py-2 border border-black rounded" @click="showLockModal"><i class="fa fa-lock"></i> {{transEdit('lock-day')}}</button>
                    <button  v-if="!selectedDayIsLocked && !monthIsLocked" class="w-full py-2 border border-black rounded" @click="showLockMonthModal"><i class="fa fa-lock"></i> {{transEdit('lock-month')}}</button>
                    <!--<button  v-if="!selectedDayIsLocked && !monthIsLocked" class="w-full py-2 border border-black rounded" @click="showAddExpenditureModal"><i class="fa fa-plus"></i> {{transEdit('register-expenditures')}}</button>-->
                    <button  v-if="!selectedDayIsLocked && !monthIsLocked" class="w-full py-2 border border-black rounded" @click="showAddAdministrativeTimeModal"><i class="fa fa-plus"></i> {{transEdit('Administrativ tid')}}</button>
                    <!--<button  v-if="!selectedDayIsLocked && !monthIsLocked" class="w-full py-2 border border-black rounded" @click="showAddScheduleModal"><i class="fa fa-plus"></i> {{transEdit('add-schedule')}}</button>-->
                    <button  v-if="!selectedDayIsLocked && !monthIsLocked" class="w-full py-2 border border-black rounded" @click="showPostRegistrationModal"><i class="fa fa-plus"></i> {{transEdit('post-registration')}}</button>
                    <button class="w-full py-2 text-red-500 border border-red-500 rounded" @click="showRemoveDayModal" v-if="!selectedDayIsLocked && !monthIsLocked"><i class="fa fa-trash"></i> {{transEdit('remove-day')}}</button>
                </div>

            </div>
            <div class="w-3/4 calendar-on-light-background">
                <calendar ref="calendar" :ajaxUrl="$portalUrl('/calendarmonth')" dateKey="start" canSelectEmpty="true" maxWidth="100%"
                          :initialDate="selectedDate" :isCustomer="false" :isTherapist="true"
                    @daySelected="daySelected"
                    @monthChanged="monthChanged"></calendar>
            </div>

        </div>

        <hr class="h-1 my-5 bg-gray-300 border-0">

        <therapist-dash-expenditures-list
                :route_expenditures="part.route_expenditures"
                :date="new Date(selectedDate)"
                :locked="selectedDayIsLocked"
                ref="expenditure"></therapist-dash-expenditures-list>

        <therapist-dash-admin-time-list
        :route_admin_time="part.route_admin_times"
        :date="new Date(selectedDate)"
        :locked="selectedDayIsLocked"
        ></therapist-dash-admin-time-list>

        <hr class="h-1 my-5 bg-gray-300 border-0">

        <therapist-dash-schedules-table
                ref="table"
                v-if="!showWeeklySchedule"
                :locked="lockedByAdmin"
                :route_bookings="part.route_bookings"
                :date="selectedDate"
                :show_daily="!showWeeklySchedule"
                v-on:new-schedules="handleNewSchedules"></therapist-dash-schedules-table>

        <therapist-dash-weekly-schedule
            ref="table"
            :route_weekly="part.route_weekly"
            :date="new Date(selectedDate)"
            :locks="locks"
            v-else></therapist-dash-weekly-schedule>

    </div>
</template>

<script>
    import TherapistDashPostRegistrationModal from './TherapistDashPostRegistrationModal.vue'

    let MonthsEnum = Object.freeze({
        1:"Januari",
        2:"Februari",
        3:"Mars",
        4:"April",
        5:"Maj",
        6:"Juni",
        7:"Juli",
        8:"Augusti",
        9:"September",
        10:"Oktober",
        11:"November",
        12:"December",
    });

    export default {
        name: "TherapistDashScheduleNew",
        props: ['part', 'do_refresh', 'initialDate', 'is_admin'],
        data () {
            return {
                selectedDate: this.initialDate ? this.initialDate : moment(),
                showWeeklySchedule: false,
                locks: [],
                absences: [],
                monthIsLocked: false,
                lockedByAdmin: false
            }
        },
        computed: {
            therapist_name: function () {
                return this.part.therapist_name;
            },
            route_reporting: function () {
                return this.part.route_reporting_page;
            },
            route_settings: function () {
                return this.part.route_settings_page;
            },
            route_surveys: function () {
                return this.part.route_surveys;
            },
            route_temp: function () {
                return this.part.route_temp;
            },
            route_vacancies: function () {
                return this.part.route_vacancies;
            },
            route_availability: function () {
                return this.part.route_availability;
            },
            route_absences: function () {
                return this.part.route_absences;
            },
            selectedDayIsLocked(){
                if(this.lockedByAdmin){
                    return true;
                }
                return _.filter(this.locks, (lock) => {
                    return lock.lock_date ==  this.selectedDate.format('YYYY-MM-DD');
                }).length > 0;
            }
        },
        watch: {
            do_refresh () {
                this.refresh();
            }
        },
        methods: {
            refresh() {
                this.getLocksForMonth();
                this.getAbsences();
                this.$refs.calendar.ajaxEvents();
                this.$refs.table.refresh();
                this.$refs.expenditure.refresh();
            },

            unlockMonth() {
                if(this.lockedByAdmin) {
                    alert('Månaden är låst av admin och kan inte låsas upp.');
                }

                if(!confirm('Är du säker på att du vill låsa upp månaden?')) {
                    return false;
                }

                axios.get(this.$portalUrl('/lock/delete?date='+this.selectedDate.format('YYYY-MM-DD')+'&month=1')).then((res) => {
                    this.refresh();
                });
            },
            getFormattedDateTime: function(date) {
                return this.getFormattedDate(date) + " " + this.getFormattedTime(date);
            },
            getFormattedDate: function(date) {
                let _date = new moment(date);
                return _date.format('YYYY-MM-DD');
            },
            getFormattedTime: function(date) {
                let _date = new moment(date);
                return _date.format('H:m');
            },
            getAbsences: function () {
                axios.get(this.$portalUrl(this.route_absences)).then((res) => {
                    this.absences = res.data;
                }).catch((err) => {
                });
            },
            getSelectedMonthAndYear: function () {
                let month = this.selectedDate.month() + 1;
                let year = this.selectedDate.year();
                return MonthsEnum[month] + ", " + year;
            },
            toggleWeekSchedule: function () {
                this.showWeeklySchedule = !this.showWeeklySchedule;
            },
            daySelected(day) {
                this.selectedDate = day.date;
                this.getLocksForMonth();
            },
            monthChanged(date) {
                this.selectedDate = null; // We first need to reset selectedDate to trigger reactivity
                this.selectedDate = date;

                this.refresh();
            },
            handleNewSchedules (newSchedules) {
            },
            showPostRegistrationModal: function () {
                this.$modal.show(TherapistDashPostRegistrationModal, {
                    'date': this.selectedDate,
                }, {
                    height: 'auto'
                });
            },
            showLockModal: function () {
              this.$eventHub.$emit('lock-day', this.selectedDate.format('YYYY-MM-DD'));
            },
            showLockMonthModal: function () {
              this.$eventHub.$emit('lock-month', this.selectedDate.format('YYYY-MM-DD'));
            },
            showRemoveDayModal: function () {
              this.$eventHub.$emit('therapist-remove-day', this.selectedDate.format('YYYY-MM-DD'));
            },
            showAddScheduleModal: function () {
              this.$eventHub.$emit('therapist-add-schedule', this.selectedDate.format('YYYY-MM-DD'));
            },
            showAddAdministrativeTimeModal: function () {
              this.$eventHub.$emit('therapist-add-admin-time', this.selectedDate.format('YYYY-MM-DD'));
            },
            showAddExpenditureModal: function () {
                this.$eventHub.$emit('add-expenditure', this.selectedDate.format('YYYY-MM-DD'));
            },
            getLocksForMonth(date = null){
                if(date){
                    date = date.format('YYYY-MM-DD')
                }else{
                    date = this.selectedDate.format('YYYY-MM-DD')
                }

                axios.get(this.$portalUrl('/lock/get?date='+this.selectedDate.format('YYYY-MM-DD')+'&month=1')).then((res) => {
                    this.locks = res.data.locks;
                    this.monthIsLocked = res.data.month_is_locked || res.data.locked_by_admin;
                    this.lockedByAdmin = res.data.locked_by_admin;
                }).catch((err) => {
                });
            }
        },
        mounted(){
            this.getLocksForMonth();
            this.getAbsences();
        }
    }
</script>

<style scoped>

</style>
